<template>
  <div class="cover-page">
    <div class="cover-page-head">
      <el-input
        v-model="searchData.shopName"
        placeholder="请输入SKU标题"
        clearable
        @clear="getTableList"
        width="200px"
        class="search-input"
      ></el-input>
      <el-button type="primary" size="small" @click="getTableList"
        >搜索</el-button
      >
      <el-button class="operation-btn" type="primary" size="mini" @click="reCreate"
        >重新生成</el-button
      >
      <el-button type="primary" size="small" @click="reset">清空</el-button>
    </div>
    <el-table
      ref="tableRef"
      v-loading="loading"
      :data="tableList"
      highlight-current-row
      style="width: 100%; margin-top: 10px"
      :max-height="maxHeight"
    >
    <!-- <el-table-column type="index" label="序号" width="80" align="center" /> -->
    <el-table-column type="sort" label="序号" width="80" align="center" >
      <template slot-scope="scope">
        <div class="merchant-name">
          <p class="name">{{ scope.row.sort }}</p>
          <div v-if="scope.row.id">
            <i
              class="el-icon-edit"
              style="margin-right: 10px"
              @click="handleClickSort(scope.row)"
            ></i> 
          </div>
        </div>
      </template>
  </el-table-column>
      
      <el-table-column
        prop="merchantName"
        label="商户名称"
        width="200"
        align="center"
      />
      <el-table-column prop="shopName" label="店铺名" align="center" />
      <el-table-column label="SKU信息" align="center" width="400">
        <template slot-scope="scope">
          <div
            class="goods-info"
            v-if="
              scope.row.goodsSkuTitle ||
              scope.row.goodsSkuName ||
              scope.row.specification ||
              scope.row.factory ||
              scope.row.approvalNumber
            "
          >
            <img
              class="goods-info-left"
              :src="scope.row.goodsSkuImage || avater"
              alt=""
            />
            <div class="goods-info-right">
              <div style="display: flex">
                <p class="color-95 text-ellipsis">商品标题</p>
                <p class="color-26 text-ellipsis">
                  {{ scope.row.goodsSkuTitle || "--" }}
                </p>
              </div>
              <p>
                <span class="color-95 text">商品名称</span>
                <span class="color-26">{{
                  scope.row.goodsSkuName || "--"
                }}</span>
              </p>
              <div style="display: flex">
                <div
                  class="color-95 text"
                  style="width: 48px; text-align-last: justify"
                >
                  规格
                </div>
                <span class="color-26">{{
                  scope.row.specification || "--"
                }}</span>
              </div>
              <div style="display: flex">
                <p class="color-95 text">生产厂家</p>
                <p class="color-26 text-ellipsis">
                  {{ scope.row.factory || "--" }}
                </p>
              </div>
              <p>
                <span class="color-95 text">批准文号</span>
                <span class="color-26">{{
                  scope.row.approvalNumber || "--"
                }}</span>
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="reason"
        label="推荐原因"
        align="center"
        min-width="200"
      /> -->
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <p @click="handleEdit(scope.row)" style="cursor: pointer">
            选择商品
          </p>
          <div class="tool-bar">
            <span
              v-if="scope.row.id"
              @click="handleDelete(scope.row)"
              :style="{
                color: scope.row.add ? 'grey' : 'red',
                cursor: scope.row.add ? 'not-allowed' : 'pointer',
              }"
              >删除</span
            >
            <span
              v-if="!scope.row.id"
              @click="handleDeleteNode(scope.row, scope.$index)"
              :style="{
                color: 'red',
                cursor: 'pointer',
              }"
              >删除</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-show="page.total > 0"
      :total="page.total"
      :page-sizes="page.pageSizes"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="getTableList"
    />
    <!-- 新增/编辑 -->
    <DlgAddGoods
      ref="addGoodsRef"
      :type="goodsType"
      @refreshList="getTableList"
    />
    <setSort ref="setSort"  @refreshList="getTableList" :appendToBody="true"/>
  </div>
</template>
<script>
/** 盖楼商品-sku补位设置 */
import avater from "/public/img/default.png";
import {
  getRecommendGoodsCoverList,
  updateRecommendGoods,
  deleteRecommendGoods,
  clearComplementGoods,
  regenerateRecommendGoods
} from "@/api/recommendationHome";
import DlgAddGoods from "./dlgAddGoods";
import Pagination from '@/components/Pagination'
import { MessageBox } from 'element-ui';
import setSort from "../components/setSort";

export default {
  name: "SkuCoverSetting",
  components: {
    DlgAddGoods,
    Pagination,
    setSort
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.tableList = [];
        this.getTableList();
      }
    }
  },
  data() {
    return {
      searchData: {},
      loading: false,
      avater: avater,
      tableList: [],
      goodsType: 3,
      maxHeight: 400,
      page: {
        current: 1,
        size: 10,
        total: 0,
        pageSizes: [10, 20, 30, 50]
      },
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    handleClickSort(row) { 
      this.$refs.setSort.show(row,'goods');
    },
    async getTableList() {
      this.loading = true;
      const { data } = await getRecommendGoodsCoverList({
        keyWords: this.searchData.shopName,
        current: this.page.current,
        size: this.page.size,
        type: this.goodsType,
        complementFlag: 1, //是否补位商品
        baseGoodsFlag: 0
      }).finally(() => (this.loading = false));
      const {records, total} = data
      records && (this.tableList = [...records]);
      this.page.total = total ?? 0;
    },
    reset() {
      MessageBox.confirm("是否清空补位数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const  res = await  clearComplementGoods(this.goodsType,{baseGoodsFlag: 0})
        res && this.$message.success("清空成功");
        res && this.getTableList();
      });
    },
    /**重新生成 */
    reCreate() {
      MessageBox.confirm("是否重新生成补位数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const  res = await  regenerateRecommendGoods(this.goodsType,{ baseGoodsFlag: 0})
        res && this.$message.success("重新生成成功");
        res && this.getTableList();
      });
    },
    handleAdd() {
      this.tableList.push({ add: true });
      this.$nextTick(() => {
        this.$refs.tableRef.bodyWrapper.scrollTop =
          this.$refs.tableRef.bodyWrapper.scrollHeight;
      });
    },

    handleEdit(row) {
      this.$refs.addGoodsRef.id = row.id;
      this.$refs.addGoodsRef.shopId = row.shopId;
      this.$refs.addGoodsRef.shopName = row.merchantName;
      this.$refs.addGoodsRef.dialogVisible = true;
    },
    handleEditReason(row) {
      if (row.add) return;
      console.log("请输入推荐原因", row);
      this.$prompt("请输入推荐原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputPlaceholder: "请输入20字以内推荐原因",
      })
        .then(({ value }) => {
          let params = {
            reason: value,
            id: row.id,
          };
          updateRecommendGoods(params).then((res) => {
            if (res.code === 0) {
              this.$message.success("操作成功");
              this.getTableList();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch((err) => {
          console.log("取消操作");
        });
    },
    handleDeleteNode(row, index) {
      this.tableList.splice(index, 1);
    },
    handleDelete(row) {
      if (row.add) return;
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteRecommendGoods(row.id);
        })
        .then(() => {
          this.getTableList();
          this.$message.success("删除成功");
        });
    },
    /**返回  */
    goBack() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.cover-page {
  &-head {
    display: flex;
    margin-bottom: 15px;
    .search-input {
      width: 200px;
      margin-right: 10px;
    }
  }

  .merchant-name {
    display: flex;
    align-items: center;
    justify-content: center;

    .name {
      flex: 1;
    }
  }

  .tool-bar {
    display: flex;
    justify-content: center;
  }

  .goods-info {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    &-left {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }

    &-right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 380px;

      .text-ellipsis {
        max-width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    p {
      margin: 0;
      height: 18px;
    }
  }

  .color-95 {
    color: #959595;
    margin-right: 10px !important;
  }
  .color-26 {
    color: #262626;
  }

  .operation-btn {
    margin-left: 80px;
  }
}
</style>